module.exports = __webpack_public_path__ + "img/icon-demo-light.1f40fc41.svg";